/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import Card from '@material-ui/core/Card';

export default class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      entries: null,
    };
    // props.setActiveComponent('No-Match');
  }

  render() {
    const year = new Date().getFullYear();
    return (
      <div id="footer">
        <img className="footer-favicon" src="https://hrf-bucket.s3.amazonaws.com/favicon-32x32.png" alt="Favicon" />
        <a href="https://www.linkedin.com/in/harrisonferlauto/" target="_blank" rel="noopener noreferrer">
          <img className="linkedin" src="https://hrf-bucket.s3.amazonaws.com/linkedin.svg" alt="Linkedin" />
        </a>
        {/* <div className="counter-wrapper">
          <a href="http://guestscounter.com">
            <img src="http://guestscounter.com/count.php?c_style=2&id=1567240374" border="0" alt="hit counter" />
          </a>
        </div> */}
        <div className="footer-text">Copyright © {year} Harrison Ferlauto</div>
      </div>
    );
  }
}
